import * as action from '../../actions/lgpd/lgpdOptionsActions';
import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import getLgpdOptions from '../../selectors/lgpdOption/getLgpdOptions';
import LgpdAdvertisingViewState from '../../store/schema/LgpdAdvertisingViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

export const toggleAllowOutlookTrackAdOptionMutator = mutator(
    action.toggleAllowOutlookTrackAdOption,
    () => {
        const options = getLgpdOptions();
        const store = getOptionsStore();
        const viewState = store.activeViewState as LgpdAdvertisingViewState;

        if (options == null || options.optInBit !== 2) {
            viewState.optInBit = 2;
        } else if (options.optInBit === 2) {
            viewState.optInBit = 1;
        }
    }
);

export const loadLgpdOptionMutator = mutator(action.loadLgpdOption, () => {
    const options = getLgpdOptions();

    // We only show the save button when options is null or optInBit is 0
    // This gives the first-time user to save the all opt-out setting without any change
    let loadingOnDirty = false;
    let returnedOptInBit: number;

    if (options == null || options.optInBit === 0) {
        loadingOnDirty = true;
        returnedOptInBit = 0;
    } else {
        returnedOptInBit = options.optInBit;
    }

    getOptionsStore().activeViewState = {
        name: ActiveItem.LgpdAdvertising,
        isDirty: loadingOnDirty,
        isLoading: false,
        optInBit: returnedOptInBit,
    } as ActiveOptionViewState;
});
